<template>
  <div class="my-5">

  <div class="row">
    <div class="col-12">
      <div class="mb-3">
        <label for="input-normal" class="form-label" :disabled="hasRequestedAuthCode">{{ $t('changePassword.enterEmailLabel') }}</label>
        <input v-model="email" class="form-control email" id="input-normal" type="email" :placeholder="$t('changePassword.emailPlaceholder')" :disabled="hasRequestedAuthCode">
      </div>
    </div>
  </div>
  <div v-if="!hasRequestedAuthCode" class="row">
    <div class="col-12">
      <button type="button" class="btn btn-primary" :disabled="!hasValidEmail" @click="requestValidation">{{ $t('changePassword.requestCodeButton') }}</button>
    </div>
  </div>
  <template v-if="hasRequestedAuthCode">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="input-normal" class="form-label">{{ $t('changePassword.enterCodeLabel') }}</label>
          <input v-model="authCode" class="form-control" id="input-normal" type="text" :placeholder="$t('changePassword.codePlaceholder')">
          <div class="form-text"><span>{{ $t('changePassword.checkSpam') }} <a href="#" @click="requestValidation">{{ $t('changePassword.requestAnotherCodeLink') }}</a>.</span></div>
          <div v-if="validationRequestError" class="text-danger">{{ validationRequestError }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="form-label" for="pass-visibility">{{ $t('changePassword.newPasswordLabel') }}</label>
        <div class="password-toggle">
          <input v-model="password1" class="form-control" type="password" id="pass-visibility1" :placeholder="$t('changePassword.newPasswordPlaceholder')">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="form-label" for="pass-visibility">{{ $t('changePassword.confirmPasswordLabel') }}</label>
        <div class="password-toggle">
          <input v-model="password2" class="form-control" type="password" id="pass-visibility2" :placeholder="$t('changePassword.confirmPasswordPlaceholder')">
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button type="button" class="btn btn-primary" :disabled="!hasPwdChangeConditions" @click="changePassword">{{ $t('changePassword.changePasswordButton') }}</button>
      </div>
    </div>
  </template>
  <div class="modal fade" id="passwordChangedModel" tabindex="-1" aria-labelledby="passwordChangedModelLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="passwordChangedModelLabel">{{ $t('changePassword.passwordChangedTitle') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form>
          <div class="modal-body">
           {{ $t('changePassword.passwordChangedMessage') }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('changePassword.continueButton') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
   <CommonModals />
</div>

</template>

<script>
import CommonModals from '/src/components/CommonModals.vue';
import { VcValidation } from '/src/visualcrossing-core/vcvalidation';
import "/src/visualcrossing-core/vccommunicator_account";
import '/src/website-core/VcUtils';
import translations from '@/translations/changepassword.js';
  


export default {
  i18n: {
      messages: translations,
    },
  name: 'changepassword',
  data() {
    return {
      email: null,
      password1: null,
      password2: null,
      authCode: null,
      hasRequestedAuthCode: false,
      hasValidatedAuthCode: false,
      forwardLocation: null,
      validationRequests: 0,
      lastValidationRequest: 0,
      validationRequestError: null,
    };
},
methods: {
  changePassword() {
    const me = this;
    vcCommunicator.changeuserpassword(me.email, me.password1, me.authCode)
      .then(() => {
        me.email = null;
        me.password1 = null;
        me.authCode = null;
        me.hasRequestedAuthCode = false;

        const target = me.$el && me.$el.querySelector("#passwordChangedModel");
        const modal = target && bootstrap.Modal.getOrCreateInstance(target);
        modal && modal.show();
        if (me.forwardLocation) {
          window.location = me.forwardLocation;
        }
      })
      .catch((error) => {
        me.hasRequestedAuthCode = false;
        console.log("Failed changePassword:" + error);

        window.VcCommonModals.showError(
          me.$t('changePassword.errorChangePasswordTitle'),
          me.$t('changePassword.errorChangePasswordMessage', { error })
        );
      });
  },
  requestValidation() {
    const me = this;
    const currentTime = new Date().getTime();
    if (me.validationRequests > 10) {
      me.validationRequestError = me.$t('changePassword.errorRequestLimit');
      return;
    }
    if ((currentTime - me.lastValidationRequest) < 30000) {
      me.validationRequestError = me.$t('changePassword.errorRequestWait');
      return;
    }
    me.validationRequestError = null;
    me.validationRequests++;

    me.lastValidationRequest = currentTime;
    me.hasRequestedAuthCode = true;

    vcCommunicator.generateAuthCode(me.email)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        me.hasRequestedAuthCode = false;
        console.log("Failed requestValidation:" + error);

        window.VcCommonModals.showError(
          me.$t('changePassword.errorRequestCodeTitle'),
          me.$t('changePassword.errorRequestCodeMessage', { error })
        );
      });
  },
},
computed: {
  hasValidEmail() {
    return this.email && VcValidation.validateEmail(this.email);
  },
  hasPwdChangeConditions() {
    const me = this;
    return me.hasValidEmail && VcValidation.validateAuthCode(me.authCode) && VcValidation.validatePassword(me.password1) && me.password1 === me.password2;
  },
},
mounted() {
  const me = this;

  me.forwardLocation = VcUtils.qs["from"] || null;

  const vcCommunicator = window.vcCommunicator;
  if (!vcCommunicator) {
    console.log("No vcCommunicator");
    return;
  }
  me.sessionId = vcCommunicator.sessionId;
  vcCommunicator.addHandler('createsession', (sessionId) => {
    me.sessionId = sessionId;
  });
  vcCommunicator.addHandler('terminatesession', () => {
    me.sessionId = null;
  });
},
components: {
  CommonModals,
},
};
</script>

<style scoped>
.validate input:invalid {
  border: 1px solid red;
}
</style>
